<script setup>
/**
 * SzInAppNotificationsToggle — toggle pra ligar/desligar o SzInAppNotifier.
 *
 * Persistido em uiSettings.enable_in_app_notifications (default true).
 * Aparece em profile/settings ao lado de AudioNotifications.
 */
import { computed, ref, watch } from 'vue';
import { useUISettings } from 'dashboard/composables/useUISettings';
import { useAlert } from 'dashboard/composables';
import { useI18n } from 'vue-i18n';

const { uiSettings, updateUISettings } = useUISettings();
const { t } = useI18n();

const enabled = ref(true);

watch(
  uiSettings,
  value => {
    const v = value?.enable_in_app_notifications;
    enabled.value = v === false ? false : true;
  },
  { immediate: true, deep: true }
);

function handleToggle(e) {
  const next = !!e.target.checked;
  enabled.value = next;
  updateUISettings({ enable_in_app_notifications: next });
  useAlert(
    t('PROFILE_SETTINGS.FORM.API.UPDATE_SUCCESS', 'Configuração atualizada')
  );
}
</script>

<template>
  <div class="sz-iann-toggle-wrap flex flex-col gap-2">
    <label class="sz-iann-toggle-row flex items-center justify-between gap-3 cursor-pointer">
      <div class="flex flex-col gap-1">
        <span class="text-sm font-medium text-n-slate-12">
          Notificações no chat
        </span>
        <span class="text-xs text-n-slate-11">
          Mostra um aviso flutuante quando chega uma nova mensagem em uma conversa
          atribuída a você. Não dispara quando você já está com a conversa aberta.
        </span>
      </div>
      <span class="sz-iann-switch" :class="{ 'sz-iann-switch--on': enabled }">
        <input
          type="checkbox"
          :checked="enabled"
          class="sz-iann-switch-input"
          @change="handleToggle"
        />
        <span class="sz-iann-switch-track" />
        <span class="sz-iann-switch-thumb" />
      </span>
    </label>
  </div>
</template>

<style scoped>
.sz-iann-toggle-row {
  padding: 12px 0;
}
.sz-iann-switch {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 20px;
  flex-shrink: 0;
}
.sz-iann-switch-input {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
  width: 100%;
  height: 100%;
  margin: 0;
}
.sz-iann-switch-track {
  position: absolute;
  inset: 0;
  background: #D4D4D4;
  border-radius: 999px;
  transition: background 0.18s ease;
}
.dark .sz-iann-switch-track {
  background: #3D3F43;
}
.sz-iann-switch-thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  background: #fff;
  border-radius: 50%;
  transition: transform 0.18s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}
.sz-iann-switch--on .sz-iann-switch-track {
  background: #388E3C;
}
.sz-iann-switch--on .sz-iann-switch-thumb {
  transform: translateX(16px);
}
</style>
